<template>
    <a href="#" aria-role="button" v-on:click.prevent="addContent">{{contentName}}
    </a>
</template>

<script>
    import Axios from 'axios'

    export default {
        created: function () {
            this.init()
        },

        data() {
            return {
                loading: true
            }
        },

        methods: {
            init: function () {
                const vm = this
                vm.loading = false
            },

            addContent: function () {
                const vm = this
                const toggleAdded = function () {
                    return Axios.get('/umbraco/api/MemberProfileApi/UpdateDashboardPreference', { params: { preference: vm.contentValue } })
                }

                Axios.all([toggleAdded()])
                    .then(Axios.spread(function (response) {

                        var returnUrl = location.href.split('?')[0] + '?profileUpdated=' + encodeURIComponent(vm.contentName)

                        if (response) {
                            location = returnUrl
                        }

                        vm.loading = false
                    }))
                    .catch(() => {
                        vm.loading = false
                    })
            }
        },

        props: {
            contentName: {
                required: true,
                type: String
            },
            contentValue: {
                required: true,
                type: String
            }
        },

        watch: {
            contentValue: function () {
                this.init()
            }
        }
    }
</script>
